import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getBiopharmaGroups = ({ onResponse, onError, body }) => {
  // It is currently necessary to prevent converting the filter
  // option keys to snake case since these values will be used
  // to search the database in the backend in their current
  // format
  const filterOptionsWithUnconvertedKeys = body.filterOptions;

  fetch(
    `/api/biopharma_groups/index_with_filters`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...convertObjectKeysToSnakeCase(body),
        filter_options: filterOptionsWithUnconvertedKeys,
      }),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
